<template>
  <div class="rapeAlign">
    <div class="alignBeforeButton">
      <div class="nxtStepBeforeButton"  v-if="systemFormVuex.currentFormScreen == 'fio'">
        <p>Еженедельный платеж составит:</p>
        <p><span>{{FixedPay | moneyFormat}}</span> <span class="rubl">a</span></p>
      </div>
      <div v-else></div>
      <div>
        <button class="svgPoint" v-on:click.prevent="submitStep">
          <IconBase :viewBox="'0 0 24 24'">
            <IconPayments></IconPayments>
          </IconBase>
          <span>Следующий шаг</span>
          <IconBase :viewBox="'0 0 16 16'">
            <TurnToRight></TurnToRight>
          </IconBase>
        </button>
      </div>
    </div>
    <afterButton
      v-if="systemFormVuex.currentFormScreen == 'fio'"
    ></afterButton>
  </div>
</template>

<script>
  import {mapGetters,mapState} from 'vuex';

  export default {
    name: "nextButton",
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      IconPayments: () => import('@/components/svg/payments-finance-36'),
      TurnToRight: () => import('@/components/svg/interface-essential-237'),
      afterButton: () => import('@/components/chunk/nxtStepAfterButton'),
    },
    methods:{
      submitStep(){

        //топорное решение от даблклика, и непонятных фризов.
        // console.log(window.dblClick);
        if (window.dblClick) return false;
        window.dblClick = true;
        // console.log(window.dblClick);

        window.scrollTo({
          left:0,
          top:this.$parent.$parent.$refs.formAlign.offsetTop,
          behavior: 'smooth'
        });
        if (this.isSertifyRegistration != 'Y') {
          window.dblClick = false;
          alert('Для продолжения, подтвердите достоверность введенных данных и согласие на обработку персональных данных');
          console.log('isSertifyRegistration')
          return false;
        }

        this.$emit('submitStep');
      },
    },
    computed: {
      ...mapGetters([
        'FixedPay',
      ]),
      ...mapState({
        isSertifyRegistration: state => state.Form.sendData.IS_I_CERTIFY_REGISTRATION,
        isSertifyMarketing: state => state.Form.sendData.IS_I_CERTIFY_MARKETING,
        systemFormVuex: state => state.Form.system,
      })
    }
  }
</script>

<style scoped>
  .rapeAlign {color: white;background: #0D5A44;text-align: center;padding-top: 1.2vw; padding-bottom: 4.1vw;}
  .nxtStepBeforeButton {padding: 4vw 0 4.3vw;}
  .nxtStepBeforeButton p:first-child {font-size: 5vw;}
  .nxtStepBeforeButton p:last-child {font-size: 10vw;font-weight: bold}
  .nxtStepBeforeButton p:last-child span:last-child {color: #94B2AA;font-size: 8vw;}



  /deep/ .visualCheckBox svg {stroke: white}
  /deep/ .visualCheckBox {background: rgba(255, 255, 255, 0.20);}

  @media screen and (min-width: 760px) {
    .rapeAlign {position: relative;left: -5.7vw;padding: 1.8vw 5.7vw;margin-top: 3vw;}
    .nxtStepBeforeButton {text-align: left;padding: 0;}
    .nxtStepBeforeButton p:first-child {font-size: 1.4vw;}
    .nxtStepBeforeButton p:last-child {font-size: 3.2vw;}
    .nxtStepBeforeButton p:last-child span:last-child {font-size: 2.3vw}


    .alignBeforeButton {display: flex;align-items: center;justify-content: space-between}
  }
  @media screen and (min-width: 1140px) {
    .rapeAlign {padding: 20px 64px;left:-64px;margin-top: 30px;}
    .nxtStepBeforeButton {padding: 12px 0 15px;}
    .nxtStepBeforeButton p:first-child {font-size: 16px;}
    .nxtStepBeforeButton p:last-child {font-size: 36px;}
    .nxtStepBeforeButton p:last-child span:last-child {font-size: 26px;}

  }
</style>
